export default __webpack_public_path__ + "static/dropdownMenu_cloud_front-ee734693165a9163bd14fdd573fd9e13.webp";